import { Component, OnInit } from '@angular/core';
import { CustomerService } from 'src/app/services/customer.service';
import { CustomerOrderDetail } from 'src/app/models/customer/customer.model';
import { AlertifyService } from 'src/app/services/Common/alertify.service';
import { Params, Router, ActivatedRoute } from '@angular/router';
import { FormBuilder } from '@angular/forms';
import { GetProductAssetModel } from 'src/app/models/product/productAssets.modal';
import { HomePageService } from 'src/app/services/home-page.service';
import { ProductResponseModel } from 'src/app/models/Home/home-list.model';
import { debug } from 'console';
import { CustomerOrderStatus } from 'src/app/Enums/order';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { ProductWarrantyDescriptionComponent } from 'src/app/modules/layoutShopModule/shop-components/product-warranty-description/product-warranty-description.component';
import { LocalstorageService } from 'src/app/services/Common/localstorage.service';

@Component({
  selector: 'app-customer-single-order-list',
  templateUrl: './customer-single-order-list.component.html',
  styleUrls: ['./customer-single-order-list.component.css']
})
export class CustomerSingleOrderListComponent implements OnInit {
  Loader: boolean = false;
  customerOrders: CustomerOrderDetail = new CustomerOrderDetail();
  productAssets: GetProductAssetModel = new GetProductAssetModel();
  id: number;
  productId: number;
  productImageResponseModel: Array<GetProductAssetModel> = new Array<GetProductAssetModel>();
  showImageinMainFrame: GetProductAssetModel = new GetProductAssetModel();
  homeProductResponseModel: ProductResponseModel = new ProductResponseModel();
  CustomerOrderStatus: typeof CustomerOrderStatus = CustomerOrderStatus;
  warrantyYearPrice1: string;
  warrantyYearPrice2: string;
  warrantyId: string;
  warrantyYearPlan: string;
  ProductIdImage: number;
  newwareentyPlan: string;
  localStorageService: LocalstorageService;
  isDiscount: boolean = true;
  customerDeliveryPrice: string;
  orderTrackingNumber: string;

  constructor(private customerService: CustomerService, private homePageService: HomePageService, private _localStorageService: LocalstorageService, private modalService: NgbModal, private _customerService: CustomerService, private alertify: AlertifyService, private route: ActivatedRoute, private router: Router, private fb: FormBuilder) { 
    this.localStorageService = _localStorageService;
    this.localStorageService.setMenu("3");
  }

  ngOnInit() {
    this.route.params.subscribe((param) => {
      this.id = +param.id
      this.productId = +param.productId
    })
    if (this.localStorageService.getToken()) {
      this.getOrdersDetail();
    } else {
      this.router.navigate(['/login'], { queryParams: { return: window.location.href } });
    }

  }

  getOrdersDetail() {
    this.Loader = true;
    this.customerOrders.id = this.id;
    this.customerService.GetCustomerOrderDetail(this.customerOrders.id).subscribe((response) => {
      this.Loader = false;
      var responseBody = JSON.parse(response._body);
      if (responseBody.isSuccess) {
        this.customerOrders = responseBody.responseData;
        this.customerDeliveryPrice = this.customerOrders.deliveryPrice;
        this.orderTrackingNumber = this.customerOrders.trackingNumber;
        this.warrantyId = this.customerOrders.warrantyId;
        this.warrantyYearPlan = this.customerOrders.warrantyYear;
        if(this.warrantyYearPlan >= "1"){
         this.newwareentyPlan = this.warrantyYearPlan;
        }
        this.ProductIdImage = this.customerOrders.productId;
        this.ProductSingleImage(this.customerOrders);
        if(this.warrantyId) {
        var durationWithPrizeList = JSON.parse(this.customerOrders.warrantyPrice);
        for (var i = 0; i < durationWithPrizeList.length; i++) {
          if (durationWithPrizeList[i].Duration == this.customerOrders.warrantyYear) {
            this.warrantyYearPrice1 = durationWithPrizeList[i].Price;
          } else if (durationWithPrizeList[i].Duration == this.customerOrders.warrantyYear) {
            this.warrantyYearPrice1 = durationWithPrizeList[i].Price;
          } else if (durationWithPrizeList[i].Duration == this.customerOrders.warrantyYear) {
            this.warrantyYearPrice1 = durationWithPrizeList[i].Price;
          } else if (durationWithPrizeList[i].Duration == this.customerOrders.warrantyYear) {
            this.warrantyYearPrice1 = durationWithPrizeList[i].Price;
          }
          else if (durationWithPrizeList[i].Duration == this.customerOrders.warrantyYear) {
            this.warrantyYearPrice1 = durationWithPrizeList[i].Price;
          } 
          if (this.customerOrders.applicationInstallationPrice == '1') {
            this.warrantyYearPrice2 = durationWithPrizeList[i].Price;
          }
        }
      }
      if(this.customerOrders.discount == 0) {
        this.isDiscount = false;
      }
        this.Loader = false;
      }
      else {
        this.alertify.error(responseBody.responseMessage)
        return;
      }
    },
      (err) => {
      });
  }

  ProductSingleImage(customerOrders) {
    var productId = customerOrders.productId;
    this.homePageService.ProductImageList(productId)
      .subscribe((response) => {
        let responseimage = JSON.parse(response._body)
        if (responseimage.isSuccess) {
          this.homeProductResponseModel = responseimage.responseData;
        } (err) => {
        }
      })
  }
  uploadImage(customerOrders) {
    this.router.navigate(['/product-page/' + customerOrders.productId]);
  }
  
  Back() {
    this.router.navigate(['/customer-order-list']);
  }

  invoice() {
    const url = this.router.serializeUrl(
      this.router.createUrlTree(['/customer-download-invoice/' + this.id]));
      window.open('#' + url, '_blank');
}

ProductWarrantyDetails(ProductWarrantyDetails) {
  localStorage.setItem('ProductId', this.id.toString());
  var modalConfig = new NgbModalConfig();
  modalConfig.size = "lg";
  modalConfig.centered = true;
  modalConfig.backdrop = false;
  modalConfig.keyboard = false;
  this._customerService.passId(ProductWarrantyDetails.id);
  let modalRef = this.modalService.open(ProductWarrantyDescriptionComponent, modalConfig);
}

ProductImage() {
  const url = this.router.serializeUrl(
    this.router.createUrlTree(['/product-page/' + this.ProductIdImage]));
    window.open('#' + url, '_blank');
}
}
